import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CtaButton from '../ctaButton/ctaButton';
import SocialIcons from '../socialIcons/socialIcons';
import { setExternalLinksTargetBlank } from '../../utils/util';
import styles from './postBody.module.scss';

function PostBody({
  slug = '',
  postContent = '',
  ctaButton = null,
  showShare = false,
  className = '',
  showContinueReading = false,
  contentType = 'Blog',
}) {
  const socialData = {
    title: 'Share',
    type: 'share',
    articleUrl: `https://www.happen.com${slug}`,
  };
  const [isContinueRead, setIsContinueRead] = useState(false);

  useEffect(() => {
    setIsContinueRead(showContinueReading);
  }, [showContinueReading]);

  return (
    <>
      <div
        itemType="https://schema.org/articleSection"
        itemProp={`${contentType === 'Blog' ? 'articleSection' : ''}`}
        className={`${styles.postBody} ${
          className && styles[className] ? styles[className] : ''
        } ${isContinueRead ? styles.hideOverflow : ''}`}
      >
        <article
          className={styles.bodyContent}
          itemType="https://schema.org/articleBody"
          itemProp={`${contentType === 'Help' ? 'text' : 'articleBody'}`}
        >
          {setExternalLinksTargetBlank(postContent)}
        </article>
        {ctaButton && ctaButton.label && (
          <div className={styles.ctaButton}>
            <CtaButton
              aria-label="link-button"
              label={ctaButton.label}
              variant={ctaButton.variant}
              color={ctaButton.color}
              type="button"
              href={ctaButton.link}
            />
          </div>
        )}
        {showShare && (
          <div className={styles.sharIcons}>
            <SocialIcons {...socialData} />
          </div>
        )}
      </div>
      {isContinueRead && (
        <div className={styles.continueReadingContainer}>
          <div className={styles.continueReading}>
            <CtaButton
              aria-label="link-button"
              label="Continue Reading"
              type="button"
              onClick={() => setIsContinueRead(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
export default PostBody;

PostBody.propTypes = {
  slug: PropTypes.string,
  postContent: PropTypes.string,
  ctaButton: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  showShare: PropTypes.bool,
  className: PropTypes.string,
  showContinueReading: PropTypes.bool,
  contentType: PropTypes.oneOf(['Blog', 'Help']),
};
